import { useEffect, useState } from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import { getTheme, toggleTheme } from "./theme";
import "./ThemeToggle.css";

const ThemeToggle = ({ className = "" }) => {
  const [theme, setThemeState] = useState(() => getTheme());

  useEffect(() => {
    const onChange = (event) => setThemeState(event.detail);
    window.addEventListener("ashtang-theme", onChange);
    return () => window.removeEventListener("ashtang-theme", onChange);
  }, []);

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className={`theme-toggle ${className}`.trim()}
      onClick={() => setThemeState(toggleTheme())}
      aria-pressed={isDark}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
    >
      {isDark ? <FaSun /> : <FaMoon />}
    </button>
  );
};

export default ThemeToggle;
